import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AppServiceService } from '../../api/app-service.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.page.html',
  styleUrls: ['./forgot-password.page.scss'],
})
export class ForgotPasswordPage implements OnInit {
  @Output() onPasswordResetSuccess: EventEmitter<any> = new EventEmitter();


  public value: any = {
    email: "",
    code: "",
    password: "",
    confirm_password: "",
  }
  public showPassword = false;
  public showrepeatPassword = false;
  public errors = false;

  constructor(public appService: AppServiceService, public router: Router) { }

  ngOnInit() {
  }

  async sendEmailToReset() {
    await this.appService.forgotPasswordEmail(this.value)
  }


  async comfirmCode() {
    await this.appService.confirmVerifyCode(this.value)
  }

  async resetPassword() {
    this.errors = false;
    if (this.value.password == this.value.confirm_password) {
      this.appService.resetOldPassword(this.value).then((response) => {

        if (this.appService.isWebVersion) this.onPasswordResetSuccess.emit();
        else this.router.navigate(['/login']);

      }, error => {
        this.appService.appObject.isLoading = false;
      });
    } else {
      this.errors = true;
    }
  }

  togglePassword(input) {
    input.type = input.type === 'password' ? 'text' : 'password';
  }

}
